import { HOMEOWNERS_BASE_URL } from '~/routes/constants';

export const AUTH0_TOKEN_TYPE = 'auth0';
export const ANON_TOKEN_TYPE = 'anon';
export type TOKEN_TYPE = typeof AUTH0_TOKEN_TYPE | typeof ANON_TOKEN_TYPE;

export const UPDATE_TOKEN = 'UPDATE_TOKEN';
export const AUTH_ERROR = 'AUTH_ERROR';
export const UPDATE_USER = 'UPDATE_USER';

export const AUTH0_REDIRECT_URL = `${window.location.origin}${HOMEOWNERS_BASE_URL}/bundle-location`;
